import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const [downloadingResume, setDownloadingResume] = useState(false);
  const [downloadingPortfolio, setDownloadingPortfolio] = useState(false);

  const contactDetails = [
    {
      icon: 'Mail',
      label: 'Email',
      value: 'contact.dishantpatel@gmail.com',
      href: 'mailto:contact.dishantpatel@gmail.com',
      description: 'Primary contact method'
    },
    {
      icon: 'Phone',
      label: 'Phone',
      value: '+91 814-147-5777',
      href: 'tel:+91 8141475777',
      description: 'Available Mon-Fri, 9AM-6PM IST'
    },
    {
      icon: 'MapPin',
      label: 'Location',
      value: 'Surat, IN',
      description: 'Open to remote opportunities'
    },
    {
      icon: 'Clock',
      label: 'Timezone',
      value: 'Indian Standard Time (IST)',
      description: 'UTC+05:30'
    }
  ];

  // const socialLinks = [
  //   {
  //     name: 'LinkedIn',
  //     icon: 'Linkedin',
  //     url: 'https://www.linkedin.com/in/dishantmadariya/',
  //     color: 'text-blue-600',
  //     description: 'Professional network & endorsements'
  //   },
  //   {
  //     name: 'GitHub',
  //     icon: 'Github',
  //     url: 'https://github.com/DishantMadariya',
  //     color: 'text-gray-800 dark:text-gray-200',
  //     description: 'Code repositories & contributions'
  //   },
  //   {
  //     name: 'Twitter',
  //     icon: 'Twitter',
  //     url: 'https://twitter.com/dishant_patel14',
  //     color: 'text-blue-400',
  //     description: 'Tech insights & industry updates'
  //   },
  //   // {
  //   //   name: 'Stack Overflow',
  //   //   icon: 'HelpCircle',
  //   //   url: 'https://stackoverflow.com/users/alexdeveloper',
  //   //   color: 'text-orange-500',
  //   //   description: 'Community contributions'
  //   // }
  // ];

  const availabilityStatus = {
    status: 'available',
    message: 'Available for new projects',
    nextAvailable: 'Immediate start possible',
    workingHours: 'Mon-Fri, 9:00 AM - 6:00 PM IST'
  };

  const handleResumeDownload = async (format) => {
    if (format === 'pdf') {
      setDownloadingResume(true);
    } else {
      setDownloadingPortfolio(true);
    }

    // Simulate download process
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Create mock download
      const link = document.createElement('a');
      link.href = format === 'pdf' ? '/assets/Dishant_Madariya_Resume.pdf' : '#';
      link.download = format === 'pdf' ? 'Dishant_Madariya_Resume.pdf' : 'Dishant_Madariya_Portfolio.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setDownloadingResume(false);
      setDownloadingPortfolio(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Availability Status */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
          <h3 className="text-lg font-semibold text-text-primary">Current Availability</h3>
        </div>

        <div className="space-y-3">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={16} color="var(--color-success)" />
            <span className="text-success font-medium">{availabilityStatus.message}</span>
          </div>

          <div className="text-sm text-text-secondary space-y-1">
            <p><strong>Next Available:</strong> {availabilityStatus.nextAvailable}</p>
            <p><strong>Working Hours:</strong> {availabilityStatus.workingHours}</p>
          </div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">Contact Information</h3>

        <div className="space-y-4">
          {contactDetails.map((contact, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={contact.icon} size={18} color="var(--color-primary)" />
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-text-primary">{contact.label}</p>
                {contact.href ? (
                  <a
                    href={contact.href}
                    className="text-primary hover:text-primary/80 transition-colors duration-200 break-all"
                  >
                    {contact.value}
                  </a>
                ) : (
                  <p className="text-text-primary break-all">{contact.value}</p>
                )}
                <p className="text-xs text-text-secondary mt-1">{contact.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Resume Download */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">Resume & Portfolio</h3>

        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon name="FileText" size={20} color="var(--color-primary)" />
              <div>
                <p className="font-medium text-text-primary">Resume (PDF)</p>
                <p className="text-sm text-text-secondary">Last updated: July 2025</p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              loading={downloadingResume}
              onClick={() => handleResumeDownload('pdf')}
              iconName="Download"
              iconPosition="left"
            >
              Download
            </Button>
          </div>

          {/* <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon name="Briefcase" size={20} color="var(--color-primary)" />
              <div>
                <p className="font-medium text-text-primary">Portfolio (PDF)</p>
                <p className="text-sm text-text-secondary">Detailed project showcase</p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              loading={downloadingPortfolio}
              onClick={() => handleResumeDownload('portfolio')}
              iconName="Download"
              iconPosition="left"
            >
              Download
            </Button>
          </div> */}
        </div>

        <div className="mt-4 p-3 bg-primary/5 rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5" />
            <p className="text-sm text-text-secondary">
              My resume is regularly updated with the latest projects and achievements. PDF format ensures compatibility across all devices and platforms.
            </p>
          </div>
        </div>
      </div>

      {/* Social Media Links
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">Connect With Me</h3>
      </div> */}

      {/* Response Time Info */}
      <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg border border-border p-6">
        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={20} color="var(--color-primary)" />
          <div>
            <h4 className="font-semibold text-text-primary mb-2">Response Time Commitment</h4>
            <ul className="text-sm text-text-secondary space-y-1">
              <li>• Email inquiries: Within 24 hours</li>
              <li>• Project proposals: Within 48 hours</li>
              <li>• Urgent matters: Same day response</li>
              <li>• Initial consultation: Usually within 2-3 days</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;